import { makeStyles } from '@material-ui/core';
import { colorPalette } from '../../colorPalette';
export const useStyles = makeStyles({
    container: {
        background: colorPalette.white,
        boxSizing: 'border-box',
        borderRadius: '5px',
        padding: '17px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: colorPalette.gray800,
        textDecoration: 'none',
        marginTop: (props) => (props.margins && props.margins.marginTop ? `${props.margins.marginTop}px` : 0),
        marginBottom: (props) => (props.margins && props.margins.marginBottom ? `${props.margins.marginBottom}px` : 0),
        marginLeft: (props) => (props.margins && props.margins.marginLeft ? `${props.margins.marginLeft}px` : 0),
        marginRight: (props) => (props.margins && props.margins.marginRight ? `${props.margins.marginRight}px` : 0),
    },
    button: {
        padding: 0,
    },
    shadowed: {
        boxShadow: '0 2px 8px #EBEBEB',
    },
    default: {
        border: '1px solid #EBEBEB',
    },
});
